import { useFragment } from 'react-relay';
import { graphql } from 'relay-runtime';

import type { collectionCardContentfulRelayFragment$key } from '@/__generated_contentful__/collectionCardContentfulRelayFragment.graphql';
import { CollectionCard } from '@/components/confluence/templates/collection-card';
import { CollectionOrderKey } from '@/templates/software/confluence/templates/confluence-templates-page/src/config/collection-order.ts';

const CollectionCardFragment = graphql`
	fragment collectionCardContentfulRelayFragment on TemplateCollection {
		sys {
			id
		}
		collectionNameExternal
		urlSlug
		collectionIcon {
			url
		}
		howToUseThisCollection {
			collectionStepsCollection {
				total
				__typename
			}
		}
	}
`;

export type CollectionCardProps = {
	collection: collectionCardContentfulRelayFragment$key;
};

export const CollectionCardRelay = ({ collection }: CollectionCardProps) => {
	const data = useFragment(CollectionCardFragment, collection);
	return (
		<CollectionCard
			urlSlug={data.urlSlug as CollectionOrderKey}
			templateCount={data.howToUseThisCollection?.collectionStepsCollection?.total ?? 0}
			name={data.collectionNameExternal ?? ''}
		/>
	);
};
